import { ApiHttpService, ApiHttpServiceNewApi } from '../ApiHttpService';
import { DepartmentSerializer } from '../serializers/DepartmentSerializer';
import { LocationSerializer } from '../serializers/LocationSerializer';
import { Department } from '../../models/Department';
import { Location } from '../../models/Location';

const DEPARTMENTS_PATH = 'Calles/departamentos/';
const LOCATIONS_PATH = 'Calles/LocalidadesDeDepto';

const NEWAPI_FIND_ZONE_BY_POINT = 'Address/find-zone-by-point';

class LocationController {
  static async getDepartments() {
    const response = await ApiHttpService.get(DEPARTMENTS_PATH);
    const deSerializedData = (response.data || []).map(DepartmentSerializer.deSerialize);
    const data = deSerializedData.map(department => new Department(department));
    data.sort((a, b) => (a.name < b.name ? -1 : 1));
    return data;
  }

  static async getLocations(departmentId) {
    const response = await ApiHttpService.get(LOCATIONS_PATH, { departamento: departmentId });
    const deSerializedData = (response.data || []).map(LocationSerializer.deSerialize);
    const data = deSerializedData.map(department => new Location(department));
    data.sort((a, b) => (a.name < b.name ? -1 : 1));
    return data;
  }

  static async getZoneByPoint(lat, lng) {
    const response = await ApiHttpServiceNewApi.get(NEWAPI_FIND_ZONE_BY_POINT, {
      latitude: lat,
      longitude: lng,
    }, true);
    return response.data.data;
  }
}

export { LocationController };



// WEBPACK FOOTER //
// ./src/networking/controllers/LocationController.js